import React from 'react';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { UnitModalContent } from './content';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
export const UnitModal = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2;
  let isOpen = _ref.isOpen,
    handleClose = _ref.handleClose;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    variant: "large",
    title: t('add_new_property_flow.unit_setup'),
    subTitle: (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) !== null && _store$homeDashboardS !== void 0 && (_store$homeDashboardS = _store$homeDashboardS.buildingInformation) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.buildingAddress ? (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.buildingInformation) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.buildingAddress : 'Property address',
    trigger: null,
    noPadding: true,
    isOpen: isOpen,
    handleClose: handleClose
  }, isOpen && /*#__PURE__*/React.createElement(UnitModalContent, {
    handleClose: handleClose
  }));
});